import styles from './FJResultActionButtons.module.less';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useMemo } from 'react';
import FJUtil from '../../../util/FJUtil';
import FJConstant from '../../../constants/FJConstant';
import FJButton, { FJButtonType } from '../../components/FJButton/FJButton';
import FJLocalStore from '../../../store/FJLocalStore';
import DownloadIcon from '../../../assets/svg/download-black.svg?react';
import VideoGradientIcon from '../../../assets/svg/video-gradient.svg?react';

const FJResultActionButtons = props => {
    const {
        taskStatus,
        headerTabIndex,
        isCanDownload,
        downloadLoading = false,
        onDownload,
        isShowImageToVideoButton = false,
        customButtons = [],
        className,
        imageToVideo,
    } = props;

    const shouldShowButtons = useMemo(() => {
        if (
            FJUtil.isGeneratingStatus(taskStatus) ||
            taskStatus === FJConstant.ERROR ||
            headerTabIndex !== FJConstant.CREATIONS ||
            !isCanDownload
        ) {
            return false;
        }

        if (window.isEditPage) return false;

        return true;
    }, [taskStatus, headerTabIndex, isCanDownload]);

    if (!shouldShowButtons) {
        return null;
    }

    return (
        <div className={classNames(styles.action_buttons_box, className)}>
            {/* 渲染自定义按钮 */}
            {customButtons.map((button, index) => (
                <FJButton
                    key={index}
                    onClick={button.onClick}
                    className={classNames(styles.custom_btn, button.className)}
                    textClassName={styles.btn_text}
                    text={FJLocalStore._(button.text)}
                    type={button.type || FJButtonType.LIGHT_GRADIENT}
                    icon={button.icon}
                    isLoading={button.isLoading}
                />
            ))}

            {isShowImageToVideoButton && (
                <FJButton
                    onClick={imageToVideo}
                    className={classNames(styles.image_to_video_btn)}
                    textClassName={styles.btn_text}
                    text={FJLocalStore._('image-to-video')}
                    type={FJButtonType.LIGHT_GRADIENT}
                    icon={<VideoGradientIcon />}
                />
            )}

            {/* 默认下载按钮 */}
            {onDownload && (
                <FJButton
                    onClick={onDownload}
                    className={classNames(styles.download_btn, downloadLoading && styles.loading)}
                    textClassName={styles.btn_text}
                    text={FJLocalStore._('download')}
                    isLoading={downloadLoading}
                    type={FJButtonType.GRADIENT}
                    icon={<DownloadIcon className={styles.download_icon} />}
                />
            )}
        </div>
    );
};

FJResultActionButtons.propTypes = {
    taskStatus: PropTypes.string,
    headerTabIndex: PropTypes.string,
    isCanDownload: PropTypes.bool,
    downloadLoading: PropTypes.bool,
    onDownload: PropTypes.func,
    customButtons: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string.isRequired,
            onClick: PropTypes.func.isRequired,
            icon: PropTypes.node,
            type: PropTypes.string,
            className: PropTypes.string,
            isLoading: PropTypes.bool,
        }),
    ),
    className: PropTypes.string,
};

export default FJResultActionButtons;
